import {StyleSheet, PixelRatio} from 'react-native';

export default StyleSheet.create({
    cheapList:{
        zIndex: 29
    },
    cheapImage:{
        height: 160,
        width: '100%',
    },
    cheapSection:{
        marginTop: -100
    },
    priceCardBlock:{
        flexDirection:'row',
        marginLeft: 8,
        marginRight: 16,
    },

});